import axios from 'axios';
import {showLoadingToast, showNotify, closeToast} from 'vant';
import router from '../router'

export function request(config){

    const instance = axios.create({
        baseURL:'https://api.shop.eduwork.cn',
        timeout:5000
    });

    //请求拦截
    instance.interceptors.request.use(config=>{

        showLoadingToast({
            message: '加载中...',
            forbidClick: true,
        });

        // 如果API需要认证， 在这统一设置
        const token = window.localStorage.getItem('token');

        if(token) {
            config.headers.Authorization = 'Bearer '+token;
        }

        return config;
    }, err=>{

    })

    //响应拦截
    instance.interceptors.response.use(res=>{
        closeToast();
        return res;
    }, err=>{
        // 如果没有授权， 去login
        if(err.response) {

            if (err.response.status == '401') {
                showNotify('请先登录')
                router.push({path: '/login'})
            }
            if (err.response.status == '500') {
                showNotify('（服务器内部错误） 服务器遇到错误，无法完成请求')
            }
            if (err.response.status == '400') {
                showNotify('（错误请求）服务器不理解请求的语法')
            }
            if (err.response.status == '422') {
                showNotify('（验证错误） 请求参数未通过验证')
            }
            // 如果有错误， 在这里可以提示
            showNotify(err.response.data.errors[Object.keys(err.response.data.errors)[0]][0])
        }
    })

    return instance(config)
}